import CopilotModule from 'src/modules/copilot/module';
import copilotSlice from 'src/modules/copilot/slice';

export const moduleList = {
  ...CopilotModule,
};

export const reducerList = {
  ...copilotSlice,
};
